var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotNowOutcome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.07692C4.72878 2.07692 2.07692 4.72878 2.07692 8C2.07692 11.2712 4.72878 13.9231 8 13.9231C11.2712 13.9231 13.9231 11.2712 13.9231 8C13.9231 4.72878 11.2712 2.07692 8 2.07692ZM1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8ZM8 3.87179C8.29738 3.87179 8.53846 4.11287 8.53846 4.41026V7.77696L10.5346 9.7731C10.7449 9.98338 10.7449 10.3243 10.5346 10.5346C10.3243 10.7449 9.98338 10.7449 9.7731 10.5346L7.61925 8.38075C7.51827 8.27977 7.46154 8.14281 7.46154 8V4.41026C7.46154 4.11287 7.70262 3.87179 8 3.87179Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotNowOutcome);
export default __webpack_public_path__ + "static/media/not_now_outcome.72e56362763239a9ef7bdbf808f2a5a7.svg";
export { ForwardRef as ReactComponent };